import { render, staticRenderFns } from "./AddGrade.vue?vue&type=template&id=31488f26&scoped=true"
import script from "./AddGrade.vue?vue&type=script&lang=js"
export * from "./AddGrade.vue?vue&type=script&lang=js"
import style0 from "./AddGrade.vue?vue&type=style&index=0&id=31488f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31488f26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
